<div>
    <form [formGroup]="form" (submit)="submit()">
        <app-form-mails [invitations]="form"></app-form-mails>
        <app-list-participant></app-list-participant>
        <div class="modal-footer">
            <button class="btn-blue" type="submit" name="aceptar" [disabled]="isSettingParticipants$ | async">{{ 'acceptButton' | translate }}</button>
        </div>
    </form>
</div>
